import React, { ReactNode } from 'react';
import { Box, useTheme } from '@mui/material';
import { getCreateProcessStyles } from 'components/modals/CreateProcessModal';

interface Props {
  children: ReactNode;
}

const CreateProcessModalPanel: React.FC<Props> = ({ children }: Props) => {
  const theme = useTheme();
  const styles = getCreateProcessStyles(theme);

  return (
    <Box
      sx={styles.panel}
      component="section"
    >
      {children}
    </Box>
  );
};

export default CreateProcessModalPanel;
